/* eslint-disable @angular-eslint/component-selector */

import { NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { DownloadableResourceItem, Product } from '@idealsupply/ngclient-webservice-inventory';

@Component({
  selector: 'product-image-viewer',
  templateUrl: './product-image-viewer.component.html',
  styleUrls: ['./product-image-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, NgFor],
})
export class ProductImageViewerComponent {
  @Input()
  public product?: Product;

  @HostBinding('class.noimage')
  public get noimage(): boolean {
    return !this.product?.images?.length;
  }

  public selectedIndex: number = 0;
  public get selectedImage(): DownloadableResourceItem | undefined {
    return this.product?.images?.length ? this.product?.images[this.selectedIndex] : undefined;
  }
}
